<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="height"
		fill="currentColor"
		class="ki ki-close"
		viewBox="0 0 24 24"
	>
		<path
			d="M12,10.6l7.8-7.8l1.4,1.4L13.4,12l7.8,7.8l-1.4,1.4L12,13.4l-7.8,7.8 l-1.4-1.4l7.8-7.8L2.8,4.2l1.4-1.4L12,10.6z"
		/>
	</svg>
</template>

<script setup lang="ts">
interface Props {
	width?: number;
	height?: number;
}
withDefaults(defineProps<Props>(), {
	width: 24,
	height: 24
});
</script>
